import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Reports = lazy(() => import('./Reports'));

const ReportsRoute: FuseRouteItemType = {
	path: '/reports',
	element: <Reports />
};

export default ReportsRoute;
